<template lang="pug" src="./navigation-mobile.pug"></template>

<script>
import api from 'api'
import axios from 'axios'
import Icon from 'components/icon/icon'
import ReferModal from 'components/modal/modal-refer-form/modal-refer-form'

export default {
  data: () => {
    return {
      props: {
        menu: {}
      },
      show: false,
      showReferModal: false
    }
  },
  created () {
    axios.get(api + '/wp-api-menus/v2/menus/2')
      .then(res => {
        this.props.menu = res.data.items
      })
  },
  components: {
    Icon,
    ReferModal
  }
}
</script>



// WEBPACK FOOTER //
// navigation-mobile.vue?e856a012